import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { integrationRagService } from "@/services/integrationRagService";
import type { IntegrationSource } from "@/lib/integrationRag/types";

export type IntegrationIndexStatus = "new" | "indexed";

export function useIntegrationIndexMap(source: IntegrationSource) {
  const { user } = useAuth();

  const { data: records = [] } = useQuery({
    queryKey: ["integration-index", user?.id, source],
    queryFn: () => integrationRagService.getIndexRecords(source),
    enabled: !!user?.id,
    staleTime: 30_000,
  });

  return useMemo(() => {
    const map = new Map<string, { status: IntegrationIndexStatus; indexedAt?: string }>();
    for (const row of records) {
      map.set(row.external_id, {
        status: "indexed",
        indexedAt: row.indexed_at,
      });
    }
    return map;
  }, [records]);
}

export function getIntegrationIndexStatus(
  externalId: string,
  indexMap: Map<string, { status: IntegrationIndexStatus }>
): IntegrationIndexStatus {
  return indexMap.get(externalId)?.status ?? "new";
}
